<template>
  <v-app>
    <v-card flat>
      <v-row class="demo-app">
        <v-col cols="12">
          <ModernCalendar 
            ref="calendar"
            :events="appointments"
            @date-selected="onDateSelected"
            @event-selected="onEventSelected"
            @event-added="onEventAdded"
            @event-updated="onEventUpdated"
          />
        </v-col>
      </v-row>

      <!-- Dialogo Detalles del Turno -->
      <v-dialog v-model="detailsDialog" max-width="500">
        <v-card v-if="selectedEvent">
             <v-toolbar :color="getEventColor(selectedEvent.status)" dark flat>
                 <v-toolbar-title>Detalles del Turno</v-toolbar-title>
                 <v-spacer></v-spacer>
                 <v-btn icon @click="detailsDialog = false"><v-icon>mdi-close</v-icon></v-btn>
             </v-toolbar>
             
             <v-card-text class="pt-4">
                 <div class="text-h6 mb-2">{{ selectedEvent.title }}</div>
                 
                 <v-list dense>
                    <v-list-item>
                        <v-list-item-icon><v-icon color="primary">mdi-clock-outline</v-icon></v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ formatDateTime(selectedEvent.start) }}</v-list-item-title>
                            <v-list-item-subtitle>Fecha y Hora</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="selectedEvent.patient_dni">
                        <v-list-item-icon><v-icon>mdi-card-account-details</v-icon></v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ selectedEvent.patient_dni }}</v-list-item-title>
                            <v-list-item-subtitle>DNI</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="selectedEvent.patient_phone">
                        <v-list-item-icon><v-icon color="green">mdi-whatsapp</v-icon></v-list-item-icon>
                        <v-list-item-content>
                             <v-list-item-title>
                                 {{ selectedEvent.patient_phone }} 
                                 <v-btn icon x-small color="green" @click="openWhatsApp(selectedEvent.patient_phone)">
                                     <v-icon>mdi-open-in-new</v-icon>
                                 </v-btn>
                             </v-list-item-title>
                             <v-list-item-subtitle>Teléfono</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-icon><v-icon>mdi-flag</v-icon></v-list-item-icon>
                        <v-list-item-content>
                             <v-chip small :color="getEventColor(selectedEvent.status)" dark class="mt-1">
                                 {{ getStatusLabel(selectedEvent.status) }}
                             </v-chip>
                        </v-list-item-content>
                    </v-list-item>
                    
                    <v-list-item v-if="selectedEvent.description">
                         <v-list-item-content>
                             <div class="font-weight-bold caption grey--text">NOTAS</div>
                             <div>{{ selectedEvent.description }}</div>
                         </v-list-item-content>
                    </v-list-item>
                 </v-list>
             </v-card-text>
             
             <v-card-actions>
                 <v-btn 
                    v-if="selectedEvent.status === 'confirmed'" 
                    color="orange" 
                    text 
                    @click="changeStatus('checked_in')"
                 >
                    <v-icon left>mdi-account-check</v-icon> En Espera
                 </v-btn>
                 
                 <v-btn 
                    v-if="selectedEvent.status === 'checked_in'" 
                    color="primary" 
                    text 
                    @click="changeStatus('done')"
                 >
                    <v-icon left>mdi-check</v-icon> Finalizar
                 </v-btn>

                 <v-spacer></v-spacer>
                 
                 <v-btn 
                    color="red" 
                    text 
                    @click="cancelAppointment"
                    v-if="selectedEvent.status !== 'cancelled' && selectedEvent.status !== 'done'"
                 >
                    Cancelar
                 </v-btn>
             </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

  </v-app>
</template>

<script>
import ModernCalendar from './ModernCalendar.vue'
import ModernSelect from './ModernSelect.vue'
import { getTurnosDoctor, cambiarEstadoTurno, cancelarTurno } from '@/services/appointmentsApi'

let utils = require('@/utils')
var dateFormat = require("dateformat")

export default {
  name: "calendar",
  components: {
    ModernCalendar,
    ModernSelect
  },
  data: function() {
    return {
      tab: null,
      items1: [
        'Calendario','Lista',
      ],
      selected: null,
      professionalName: '',
      appointments: [],
      profesional: [],
      pacientes: [],
      nombres: [],
      items: [],
      turno: {
        profesional_name: '',
        start: '',
        end: '',
      },
      detailsDialog: false,
      selectedEvent: null,
      loading: false
    }
  },
  mounted() {
    this.loadAppointments()
  },
  methods: {
    async loadAppointments() {
      try {
        // Usar el nuevo API unificado
        const citas = await getTurnosDoctor(false);
        
        this.appointments = citas.map(function(appointment) {
          return {
            id: appointment.id,
            title: appointment.nombre || appointment.title || 'Sin nombre',
            description: appointment.notes || '',
            start: appointment.start,
            end: appointment.end,
            type: 'appointment',
            patient_id: appointment.patient_id,
            patient_dni: appointment.ci || appointment.dni || '',
            patient_phone: appointment.telefono || appointment.phone || '',
            status: appointment.state
          };
        });
        
        
      } catch (error) {
        console.error('Error loading appointments:', error);
        this.$store.commit('showSnackbar', {
          text: 'Error al cargar las citas',
          color: 'error'
        });
      }
    },
    onDateSelected(date) {
      // Aquí puedes agregar lógica para cuando se selecciona una fecha
    },
    onEventSelected(event) {
      // Aquí puedes agregar lógica para cuando se selecciona un evento
      this.showEventDetails(event)
    },
    onEventAdded(event) {
      // Aquí puedes agregar lógica para crear una nueva cita
      this.createAppointment(event)
    },
    onEventUpdated(event) {
      // Aquí puedes agregar lógica para actualizar una cita
      this.updateAppointment(event)
    },
    showEventDetails(event) {
      this.selectedEvent = event
      this.detailsDialog = true
    },
    
    async changeStatus(newStatus) {
        if (!this.selectedEvent) return
        try {
            this.loading = true
            await cambiarEstadoTurno(this.selectedEvent.id, newStatus)
            this.detailsDialog = false
            this.$store.commit('showSnackbar', { text: 'Estado actualizado', color: 'success' })
            this.loadAppointments()
        } catch(e) {
            this.$store.commit('showSnackbar', { text: 'Error al actualizar', color: 'error' })
        }finally{
            this.loading = false
        }
    },
    
    async cancelAppointment() {
         if (!confirm('¿Está seguro de cancelar este turno?')) return
         try {
            this.loading = true
            await cancelarTurno(this.selectedEvent.id)
            this.detailsDialog = false
            this.$store.commit('showSnackbar', { text: 'Turno cancelado', color: 'success' })
            this.loadAppointments()
        } catch(e) {
            this.$store.commit('showSnackbar', { text: 'Error al cancelar', color: 'error' })
        }finally{
            this.loading = false
        }
    },

    openWhatsApp(phone) {
      if (!phone) return;
      let cleanPhone = phone.replace(/\D/g, '');
      if (!cleanPhone.startsWith('54')) {
        if (cleanPhone.startsWith('0')) cleanPhone = cleanPhone.substring(1);
        cleanPhone = '54' + cleanPhone;
      }
      window.open('https://wa.me/' + cleanPhone, '_blank');
    },

    formatDateTime(dateStr) {
        if (!dateStr) return ''
        const d = new Date(dateStr)
        return d.toLocaleString('es-AR', { dateStyle: 'long', timeStyle: 'short' })
    },

    getEventColor(status) {
        const colors = {
          'free': 'green',
          'confirmed': 'blue',
          'checked_in': 'orange',
          'done': 'grey',
          'cancelled': 'red'
       }
       return colors[status?.toLowerCase()] || 'primary'
    },
    
    getStatusLabel(status) {
         const labels = {
            'free': 'Libre',
            'confirmed': 'Confirmado',
            'checked_in': 'En Espera',
            'done': 'Terminado',
            'cancelled': 'Cancelado'
        }
        return labels[status?.toLowerCase()] || status
    },

    async createAppointment(event) {
      // Implementar creación si es necesario o redireccionar
      this.$store.commit('showSnackbar', {
           text: 'Función de crear turno en desarrollo',
           color: 'info'
      })
    },
    
    async updateAppointment(event) {
       // Placeholder
    }
  }
}
</script>

<style scoped>
.demo-app {
  height: 100%;
}

.full-calendar {
  height: 600px;
}
</style>